const config = {
  rowSelection: false,
  columns: [
    {
      title: '跟进计划ID',
      dataIndex: 'id',
      width: 190,
    },
    {
      title: '客户姓名',
      dataIndex: 'name',
      width: 130,
      ellipsis: true,
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      width: 140,
      render: 'checkPhone',
    },
    {
      title: '楼盘名称',
      dataIndex: 'buildingName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '房屋属性',
      dataIndex: 'houseNatureName',
      width: 160,
    },
    {
      title: '房屋类型',
      dataIndex: 'designStyleName',
      width: 160,
    },
    {
      title: '客户来源',
      dataIndex: 'channelName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '所属门店',
      dataIndex: 'orgName',
      width: 160,
      ellipsis: true,
    },
    {
      title: '营销员',
      dataIndex: 'sales',
      width: 160,
      ellipsis: true,
    },
    {
      title: '设计师',
      dataIndex: 'designer',
      width: 160,
      ellipsis: true,
    },
    {
      title: '进入公海原因',
      dataIndex: 'reasonDesc',
      width: 200,
      ellipsis: true,
    },
    {
      title: '无效时间',
      dataIndex: 'invalidTime',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 160,
      render: 'renderOperate',
      fixed: 'right'
    },
  ],
  search: [
    {
      name: 'nameLike',
      label: '客户姓名',
    },
    {
      name: 'phone',
      label: '客户电话',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'bizOpId',
      label: '跟进计划ID',
    },
    {
      name: 'channelId',
      label: '客户来源',
      itemType: 'tree',
      data: 'channel',
      labelKey: 'label',
      key: 'id',
      allowClear: true,
      showSearch: true,
    },
    {
      name: 'buildingId',
      label: '楼盘名称',
      itemType: 'custom',
      render: 'buildRender',
    },
    {
      name: 'houseNatureCode',
      label: '房屋属性',
      itemType: 'select',
      data: 'houseNatureEnums',
      labelKey: 'description',
      key: 'key'
    },
    {
      name: 'orgId',
      label: '所属组织',
      itemType: 'select',
      data: 'companyList',
      labelKey: 'name',
      key: 'id',
      events: ['onChange:onChangeOrg'],
      allowClear: true,
      showSearch: true,
    },
    {
      name: 'leader',
      label: '负责人',
      itemType: 'custom',
      render: 'personRender',
    },
    {
      name: 'partner',
      label: '协作人',
      itemType: 'custom',
      render: 'personRender',
    },
    {
      name: 'status',
      label: '客户状态',
      itemType: 'select',
      data: 'trackPlanStatusEnums',
      labelKey: 'description',
      key: 'key'
    },
    {
      name: 'createdTime',
      label: '创建时间',
      placeholder: ['时间起', '止'],
      itemType: 'autoDate',
      showTime: 'true',
    },
    {
      name: 'invalidTime',
      label: '无效时间',
      placeholder: ['时间起', '止'],
      itemType: 'autoDate',
      showTime: 'true',
    },
  ],
}

export default config
